module.exports = __webpack_public_path__ + "media/videos/term-bg-4-1d5db223.jpg";